import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { ProviderSidebarComponent } from '../sidebar/provider-sidebar.component';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { OrgAdminManageContributionsComponent } from '../../org-admin/manage-contributions/manage-contributions.component';

@Component({
  selector: 'app-provider-manage-contribution',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    ProviderSidebarComponent,
    PageHeaderComponent,
    OrgAdminManageContributionsComponent,
  ],
  templateUrl: './manage-contribution.component.html',
  styleUrl: './manage-contribution.component.scss',
})
export class ProviderManageContributionComponent {}
